// src/components/CacheBuster.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import packageJson from '../../package.json'

const CacheBuster = () => {
      const location = useLocation();
  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Fetch meta.json without using cache
        const response = await fetch(`/meta.json?ts=${Date.now()}`, {
          cache: "no-store"
        });

        if (!response.ok) {
          console.error("Failed to fetch meta.json");
          return;
        }

        const { version: latestVersion } = await response.json();

        // Current app version (from package.json or env)
        const currentVersion = packageJson.version;
        if (latestVersion && currentVersion && latestVersion !== currentVersion) {
          console.log(`New version detected: ${latestVersion}`);
          // Clear caches and reload
          if ("caches" in window) {
            const cacheNames = await caches.keys();
            await Promise.all(cacheNames.map(name => caches.delete(name)));
          }
          window.location.reload(true);
        }
      } catch (error) {
        console.error("Error checking app version:", error);
      }
    };

    // Check immediately and periodically
    checkVersion();
    const interval = setInterval(checkVersion, 60000); // every 1 min
    return () => clearInterval(interval);
  }, [location]);

  return null; // This component doesn't render anything
};

export default CacheBuster;